import React from 'react';
import Hero from '../components/home/Hero';
import TrustBadges from '../components/home/TrustBadges';
import FeaturedProducts from '../components/home/FeaturedProducts';
import RegistryPromo from '../components/home/RegistryPromo';
import Testimonials from '../components/home/Testimonials';
import FAQSection from '../components/home/FAQSection';
import { motion } from 'framer-motion';

const Home = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Hero />
      <TrustBadges />
      <FeaturedProducts />
      <RegistryPromo />
      
      {/* Gift Guide Banner */}
      <section className="py-16 bg-luma-sage/20">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h3 className="font-serif text-3xl mb-4">Attending a Baby Shower?</h3>
          <p className="text-luma-text/70 mb-8 max-w-xl mx-auto">Skip the guesswork. Our curated Parent Gift Bundles are beautifully packaged and guaranteed to be loved.</p>
          <button className="border border-luma-primary text-luma-primary px-8 py-3 rounded-full font-medium hover:bg-luma-primary hover:text-white transition-colors">
            Shop Gift Guide
          </button>
        </div>
      </section>

      <Testimonials />
      <FAQSection />
    </motion.div>
  );
};

export default Home;